import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update patient profile
 */
export default async function putPatientProfile(
  patientUserId: string,
  nextPatient: PatientProfileUpdate,
  onBehalfOf?: string,
): Promise<PatientProfileResponse> {
  if (!patientUserId) {
    throw new Error("no patient");
  }
  const res = await fetchOrchidAPI(
    `/api/users/v1/patient_profile/${patientUserId}${
      onBehalfOf ? `?on_behalf_of=${onBehalfOf}` : ""
    }`,
    {
      method: "PUT",
      body: JSON.stringify(nextPatient),
    },
  );
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
